/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DisableSuperstackingRequest} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'
import {DisableSuperstackingResponse} from '@cash-web/protos/squareup/cash/cryptoinvestflow/service/superstacking.pb'


export const disableSuperstacking = (request: DisableSuperstackingRequest, options?: CashRequestOptions) => post<DisableSuperstackingRequest, DisableSuperstackingResponse>("/2.0/cash/disable-superstacking", request, {...options, rejectOnError: true })